import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import Logo from "../assets/images/front/logo.png";
import { Link, NavLink } from "react-router-dom";
import Image from "../components/elements/Image";
import { classNames } from "../helpers/classNames";
import Button from "../components/form/front/Button";
import User1 from "../assets/images/front/user01.webp";
import useScrollState from "../hooks/useScrollState";

const FrontHeader = () => {
  const isScrolled = useScrollState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const menudata = [
    { link: "/", name: "Find Job" },
    { link: "/review", name: "Company Review" },
  ];

  return (
    <>
      {/* ================= HEADER ================= */}
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.25, ease: "easeInOut" }}
        className={classNames(
          "fixed top-0 left-0 right-0 h-24 flex items-center z-[999] overflow-hidden",
          isScrolled ? "bg-palatte2" : "bg-transparent"
        )}
      >
        <div className="relative w-full px-4 sm:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
          <div className="flex items-center gap-x-6">
            
            <div className="h-9 xls:h-11 aspect-[5/1]">
              <Link to="/">
                <Image src={Logo} classes="object-contain" />
              </Link>
            </div>

            {/* DESKTOP MENU */}
            <div className="hidden lg:flex mx-auto gap-6">
              {menudata.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.link}
                  className={({ isActive }) =>
                    classNames(
                      "px-4 py-2 text-lg xls:text-xl font-semibold transition-all",
                      isActive ? "text-white" : "text-white"
                    )
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </div>

            {/* RIGHT ACTIONS */}
            <div className="flex items-center gap-4 ml-auto">
              <Button
                buttonIcon="fa-regular fa-bell"
                buttonClasses="bg-transparent hover:bg-palatte text-xl xls:text-2xl"
              />
              <div className="w-12 xls:w-16 aspect-square rounded-full overflow-hidden hidden sm:block">
                <Image src={User1} classes="object-cover" />
              </div>

              {/* MOBILE MENU BUTTON */}
              <button
                className="lg:hidden text-white text-2xl"
                onClick={() => setIsSidebarOpen(true)}
              >
                <i className="fa-regular fa-bars" />
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* ================= SIDEBAR ================= */}
      <AnimatePresence>
        {isSidebarOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsSidebarOpen(false)}
              className="fixed inset-0 bg-black z-40 overflow-hidden"
            />
            <motion.aside
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="fixed top-0 left-0 w-72 h-full bg-palatte2 z-50 p-6 flex flex-col"
            >
              <div className="flex items-center justify-between mb-8">
                <Image src={Logo} classes="object-contain h-10" />
               
              </div>

              {/* MENU */}
              <nav className="flex flex-col gap-4">
                {menudata.map((item, index) => (
                  <NavLink
                    key={index}
                    to={item.link}
                    onClick={() => setIsSidebarOpen(false)}
                    className={({ isActive }) =>
                      classNames(
                        "text-lg font-semibold transition-all",
                        isActive ? "text-palatte" : "text-white"
                      )
                    }
                  >
                    {item.name}
                  </NavLink>
                ))}
              </nav>

              {/* USER */}
              <div className="mt-auto flex items-center gap-3 pt-6 border-t border-white/20">
                <div className="w-12 aspect-square rounded-full overflow-hidden">
                  <Image src={User1} classes="object-cover" />
                </div>
                <span className="text-white font-medium">Profile</span>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default FrontHeader;
